import { createRequest } from "helpers/tools";

export const deleteSource = async (id) => {
    return await createRequest({
        suffix: `sources/${id}`,
        method: "delete",
        handleError: false,
    });
};
export const deleteSourceFromTracker = async (
    tracker_id,
    source_id,
    is_delete,
) => {
    let suffix = `trackers/${tracker_id && tracker_id}/sources/${
        source_id && source_id
    }`;

    if (is_delete !== undefined && is_delete === true) {
        suffix = suffix + "?delete_everywhere=1";
    }

    return await createRequest({
        suffix,
        method: "delete",
        handleError: false,
    });
};
